




































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import DataTableAttempts from '@/app/shared/components/data-tables/attempts.vue';
import ContentPaymentInfo from '@/app/shared/components/contents/payment-info.vue';
import {
  CampaignModel,
  CommunicationResponseModel,
  InteractionModel,
  TrackingsType,
} from '@/app/shared/models';
import CampaignResend from '@/app/shared/components/dialogs/campaign-resend.vue';
interface HeaderType {
  text: string;
  value: string;
  sortable?: boolean;
  align?: string;
}
@Component({
  components: { DataTableAttempts, ContentPaymentInfo, CampaignResend },
})
export default class DialogCampaignDetailsComponent extends Vue {
  @Prop(Boolean) readonly value!: boolean;
  private headers: HeaderType[] = [];
  @Prop(CampaignModel) readonly campaignTemp?: CampaignModel;
  private openDialogContent = false;
  private contentMessage = '';
  public items: CommunicationResponseModel[] = [];
  public openModalHistoryTracking = false;
  public openModalSendEmail = false;
  public historyTracking: TrackingsType[] = [];

  public resendItem: CommunicationResponseModel = {
    CampaignId: '',
    CommunicationId: '',
    ContractId: '',
    Recipient: '',
    Tracking: '',
    TypeId: this.refs.enums.TypeIdEnum.Email,
    Scheduled: new Date(),
    TrackingDate: new Date(),
    Content: '',
    MessageId: '',
    Trackings: [],
    Id: '',
    Subject: '',
    Provider: '',
    MerchantKey: '',
    RecipientId: '',
    ReturnDescription: '',
    LinkExpirationDays: 30,
    LinkExpired: false,
    LinkValidity: new Date(),
  };
  public headersTracking: HeaderType[] = [
    {
      text: this.$t('headers.last_tracking_date').toString(),
      value: 'TrackingDate',
    },
    {
      text: this.$t('headers.last_tracking').toString(),
      value: 'Tracking',
    },
  ];

  @Watch('campaignTemp')
  private async getCommunications() {
    try {
      const comResponse:
        | CommunicationResponseModel[]
        | undefined = await this.CommunicationsV2();
      if (comResponse) {
        this.items = comResponse.sort(
          (a: CommunicationResponseModel, b: CommunicationResponseModel) => {
            return (
              new Date(b.TrackingDate).getTime() -
              new Date(a.TrackingDate).getTime()
            );
          }
        );
      }
    } catch (err) {
      throw new Error('Error' + err);
    }
  }

  private setMessage(item: CommunicationResponseModel) {
    this.resendItem = item;
    this.contentMessage = item.Content;
    this.openDialogContent = true;
  }

  private setOpenHistoryTracking(item: CommunicationResponseModel) {
    this.historyTracking = item.Trackings;
    this.openModalHistoryTracking = true;
  }

  private async created(): Promise<void> {
    this.headers = [
      {
        text: this.$t('headers.contact_method').toString(),
        value: 'TypeId',
      },
      {
        text: this.$t('headers.recipient').toString(),
        value: 'Recipient',
      },
      {
        text: this.$t('headers.subject').toString(),
        value: 'Subject',
      },
      {
        text: this.$t('headers.sent_date').toString(),
        value: 'Scheduled',
        sortable: true,
      },
      {
        text: this.$t('headers.last_tracking').toString(),
        value: 'Tracking',
      },

      {
        text: this.$t('headers.template_view').toString(),
        value: 'Content',
      },
      { text: '', value: 'Actions', sortable: false, align: 'end' },
    ];
    this.getCommunications();
  }

  private get refs() {
    return refsService;
  }

  // private get installment() {
  //   return this.refs.modules.contract.installment;
  // }
  // private get installmentPaymentInfo() {
  //   return this.refs.modules.contract.installmentPaymentInfo;
  // }

  private async CommunicationsV2(): Promise<
    CommunicationResponseModel[] | undefined
  > {
    if (this.campaignTemp && this.campaignTemp.NotifyQuery) {
      this.refs.modules.loading.SET_REQUEST(true);
      const communications: CommunicationResponseModel[] = [];

      const uniqueId = [...new Set(this.campaignTemp.NotifyQuery)];
      const notifyId = this.campaignTemp.NotifyId;

      for (let index = 0; index < uniqueId.length; index++) {
        const element = uniqueId[index];
        const data = {
          campaignId: element,
          communicationId: this.refs.modules.contract.contract.Id,
          notifyId: notifyId,
        };
        const _communications = this.refs.modules.notify.getCommunicationsByCampaign(
          data
        );
        const response = await _communications;

        response.forEach((com) => {
          communications.push(com);
        });
      }

      const groupCommunicationByMessage: CommunicationResponseModel[] = [];

      communications.forEach((com: CommunicationResponseModel) => {
        com.Trackings = [];
        const index = groupCommunicationByMessage.findIndex(
          (gc) => gc.MessageId == com.MessageId
        );

        if (index == -1) {
          com.Trackings.push({
            Tracking: com.Tracking,
            TrackingDate: com.TrackingDate,
            ReturnDescription: com.ReturnDescription,
          });
          groupCommunicationByMessage.push(com);
        } else {
          groupCommunicationByMessage[index].Trackings.push({
            Tracking: com.Tracking,
            TrackingDate: com.TrackingDate,
            ReturnDescription: com.ReturnDescription,
          });
        }
      });

      groupCommunicationByMessage.forEach((gc) => {
        gc.Trackings = gc.Trackings.sort(function(a, b) {
          return (
            new Date(b.TrackingDate).getTime() -
            new Date(a.TrackingDate).getTime()
          );
        });

        const lastTracking = gc.Trackings.slice(0);

        if (lastTracking && lastTracking[0].TrackingDate) {
          gc.TrackingDate = lastTracking[0].TrackingDate;
          gc.Tracking = lastTracking[0].Tracking;
          gc.ReturnDescription = lastTracking[0].ReturnDescription;
        }
      });

      this.refs.modules.loading.SET_REQUEST(false);
      return groupCommunicationByMessage;
    }

    return undefined;
  }

  //Implementação inicial, manter até correção no backend
  private async Communications(): Promise<
    CommunicationResponseModel[] | undefined
  > {
    if (
      this.campaignTemp &&
      this.campaignTemp.CampaignId &&
      this.campaignTemp.CommunicationId
    ) {
      const data = {
        campaignId: this.campaignTemp.CampaignId,
        communicationId: this.refs.modules.contract.contract.Id,
      };

      const communications = await this.refs.modules.notify.getCommunicationsByCampaign(
        data
      );

      const groupCommunicationByMessage: CommunicationResponseModel[] = [];

      communications.forEach((com: CommunicationResponseModel) => {
        com.Trackings = [];
        const index = groupCommunicationByMessage.findIndex(
          (gc) => gc.MessageId == com.MessageId
        );

        if (index == -1) {
          com.Trackings.push({
            Tracking: com.Tracking,
            TrackingDate: com.TrackingDate,
            ReturnDescription: com.ReturnDescription,
          });
          groupCommunicationByMessage.push(com);
        } else {
          groupCommunicationByMessage[index].Trackings.push({
            Tracking: com.Tracking,
            TrackingDate: com.TrackingDate,
            ReturnDescription: com.ReturnDescription,
          });
        }
      });

      groupCommunicationByMessage.forEach((gc) => {
        gc.Trackings = gc.Trackings.sort(function(a, b) {
          return (
            new Date(b.TrackingDate).getTime() -
            new Date(a.TrackingDate).getTime()
          );
        });

        const lastTracking = gc.Trackings.slice(0);

        if (lastTracking && lastTracking[0].TrackingDate) {
          gc.TrackingDate = lastTracking[0].TrackingDate;
          gc.Tracking = lastTracking[0].Tracking;
          gc.ReturnDescription = lastTracking[0].ReturnDescription;
        }
      });

      return groupCommunicationByMessage;
    }

    return undefined;
  }

  private async openModalResend(item: CommunicationResponseModel) {
    this.resendItem = item;
    this.openModalSendEmail = true;
  }

  private async resend(recipients: string[]) {
    const type = this.refs.enums.TypeIdEnum[this.resendItem.TypeId];

    await Promise.all(
      recipients.map(async (recipient) => {
        if (recipient) {
          const data = {
            Type: type,
            Content: this.resendItem.Content,
            Recipient: recipient,
            Subject: this.resendItem.Subject || '--',
            Origin: 'Customer',
            OriginId: this.resendItem.RecipientId,
            Provider: this.resendItem.Provider,
            MerchantKey: this.resendItem.MerchantKey,
          };
          return await this.refs.modules.notify.SendMessage(data);
        }
      })
    ).then((responses) => {
      const index = responses.findIndex((result) => result && result.ok);
      if (responses && index >= 0) {
        this.$toast.success(this.$t('toasts.resend_message_campaign'));
        if (type == this.refs.enums.TypeIdEnum.Sms) {
          this.refs.modules.ticket.createInteraction(
            new InteractionModel(
              this.$t('action_code.ac22'),
              this.$t('action_desc.ad54')
            )
          );
        } else {
          this.refs.modules.ticket.createInteraction(
            new InteractionModel(
              this.$t('action_code.ac22'),
              this.$t('action_desc.ad53')
            )
          );
        }
      }
    });
  }

  private async sendIntermediateEmail() {
    if (
      this.campaignTemp &&
      this.campaignTemp.InstallmentCampaigns &&
      this.campaignTemp.InstallmentCampaigns.length > 0
    ) {
      const installmentId =
        this.campaignTemp.InstallmentCampaigns[0].InstallmentId || '';
      const retorno = await this.refs.modules.contract.sendIntermediateEmail({
        contractId: this.refs.modules.contract.contract.Id,
        installmentId: installmentId,
      });
      if (retorno.ok == true) {
        this.$toast.success(this.$t('action_desc.ad52'));
      } else {
        this.$toast.error(retorno.message);
      }
      this.openDialogContent = false;
      this.refs.modules.ticket.createInteraction(
        new InteractionModel(
          this.$t('action_code.ac24'),
          this.$t('action_desc.ad60')
        )
      );
    } else {
      this.$toast.warning(this.$t('action_desc.ad6'));
    }
  }
}
